<template>
  <div>
    <section class="content_section" v-if="options.showBrandSettings">
    <div style="display: flex; justify-content: space-between; padding-right: 2rem;">
      <h1 style="padding-left: 20px; margin-top: -1rem;">{{ options.Lang.Brandings }}</h1>
      <md-button class="md-raised md-primary" @click="showNewBrandModal = true">{{ titleCase(options.Lang.neuesBranding) }}</md-button>
    </div>

    <div class="brandGrid" v-if="renderComp">
      <div v-for="(brand, index) in brands" :key="index" class="brandCard" @click="editBrand(brand.id)">
        <div class="brandCard__logo">
          <img v-if="brand.baseLogo" :src="brand.baseLogo" class="brandLogo" alt="" />
          <md-icon v-else class="brandCard__placeholder">mode_standby</md-icon>
        </div>
        <p class="brandCard__name">{{ brand.adresse }}</p>
        <div class="brandCard__actions">
          <md-button class="md-icon-button" @click.stop="deleteBrand(brand)"><md-icon class="icon">delete</md-icon></md-button>
        </div>
      </div>
    </div>

    <Success :options="options"></Success>
    </section>

    <Brand v-if="options.showBrandForm"
           :options="options"
           @brand-updated="handleBrandUpdate"
           :id="this.brandId"/>

    <NewBrandingModal v-if="showNewBrandModal"
           :options="options"
           @close="showNewBrandModal = false"
           @created="onBrandingCreated" />

    <DeleteBrand v-if="showDeleteBrand" 
      :branding="brandToDelete"
      :id="brandToDelete.id"
      :options="options"
      :allBrands="brands"
      :boolean-prop="showDeleteBrand"
      @update-boolean="updateshowDeleteModal"
      @active-delete="deleteBranding">
    </DeleteBrand>
  </div>
 

</template>

<script>
import * as moment from 'moment'
import Success from '../../components/dialogs/Success.vue'
import Brand from '../../components/dialogs/editBrand.vue'
import DeleteBrand from '../../components/dialogs/DeleteModal.vue'
import NewBrandingModal from '../../components/dialogs/NewBrandingModal.vue'



export default {
  name: 'settings',
  components: {
    Success, Brand, DeleteBrand, NewBrandingModal
  },
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showDeleteBrand: false,
      brandToDelete: null,
      renderComp: false,
      brands: [],
      showNewBrandModal: false
    }
  },
  beforeCreate() {
  },
  beforeMount() {
  },
  created() {
    this.getModules();
    
  },
 
  mounted() {
    // Reset to the list view. These flags live on the shared `options` object, so a
    // leftover `showBrandForm = true` from a previous visit (e.g. navigating away via
    // the side-nav instead of the editor's Close button) would otherwise render the
    // full editor form under the list when returning here.
    this.options.showBrandForm = false
    this.brandId = null
    this.options.showBrandSettings = true
  },
  methods: {
    // Title-case for display only (the lang value "neues Branding" is lowercase).
    titleCase(str) {
      if (!str) return '';
      return String(str).replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1));
    },
    handleBrandUpdate(updatedBrand) {
      // Find and update the brand in the local brands array
      const brandIndex = this.brands.findIndex(brand => brand.id == updatedBrand.id);
      if (brandIndex !== -1) {
        this.brands[brandIndex].adresse = updatedBrand.adresse;
      }
    },
    abort() {
      window.setTimeout(function(){location.reload();}, 1000)
      
    },
    async deleteBranding(id, ersatzId, newBoolean) {
      this.showDeleteBrand = newBoolean;
      let self = this;
      let updateData = {
        id: id,
        ersatzId: ersatzId
      }
      //branding tauschen für trips
      await this.doPost({ data: updateData }, 'changeBrandingTrips', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          //
        }
      });
      //branding löschen
      await this.doPost({ data: updateData }, 'deleteBrand', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
        }
      });
      await self.resetpdfs();
      await window.setTimeout(self.abort(), 1500);
    },
    updateshowDeleteModal(newBoolean) {
      this.showDeleteBrand = newBoolean
    },
    async resetpdfs(){
      let data = {
			  tripId : "allall"
		}
      let self = this;
      await self.doPost({data: data}, 'setStatusPdf', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        //self.pdfReset = false;
      }
    });
    },
    editBrand(id){
      this.options.showBrandSettings = false
      if(id == "neu"){
        this.brandId = null;
      }else{
        this.brandId = id;
      }
      this.options.showBrandForm = true;
    },
    // After the modal creates the branding, refresh the list and open the full
    // editor on the new id so the user fills in the rest of the details.
    onBrandingCreated(payload) {
      this.showNewBrandModal = false;
      this.getModules();
      if (payload && payload.id) {
        this.editBrand(payload.id);
      }
    },
    
    getModules(){
      this.renderComp = false;
      let self = this;
      self.brands = []
    self.doPost({}, 'getAllBranding', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        for(let i = 0; i < result.length; i++){
          self.brands.push(result[i])
        
        }
        self.renderComp = true;

      }
    });
    },

    deleteBrand(brand){
      this.brandToDelete = brand;
      this.showDeleteBrand = true;
    }
  }
};
</script>
<style scoped>
.iconHandler{
  margin-top: 1rem;
  width: 5rem;
  align-content: center;
  display: flex;
  margin-left: -2rem !important;
  justify-content: space-between;
}

.icon:hover{
  cursor: pointer;
}
/* Branding cards — 4 per row */
.brandGrid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1.25rem;
  padding: 20px;
}
@media only screen and (max-width: 1500px) { .brandGrid { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
@media only screen and (max-width: 1140px) { .brandGrid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media only screen and (max-width: 700px)  { .brandGrid { grid-template-columns: 1fr; } }

.brandCard {
  position: relative;
  background-color: white;
  border: 1px solid #ececec;
  border-radius: 1rem;
  padding: 1.5rem 1.25rem 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.9rem;
  cursor: pointer;
  transition: box-shadow .2s ease, transform .2s ease;
}
.brandCard:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.brandCard__logo {
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.brandLogo {
  max-width: 100%;
  max-height: 90px;
  object-fit: contain;
}
.brandCard__placeholder {
  font-size: 40px !important;
  color: #c4c4c4 !important;
}
.brandCard__name {
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin: 0;
  word-break: break-word;
}
.brandCard__actions {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  display: flex;
  gap: 0.1rem;
}
h1 {
  font-size: 32px;
}



@media only screen and (max-width: 1500px) {
 
}

@media only screen and (max-width: 1240px) {


}

@media only screen and (max-width: 1140px) {
 
}</style>